import { Check } from "@mui/icons-material";
import { apiFactorsList } from "api/factorApi";
import { apiPersonsList } from "api/personApi";
import FactorIcon from "assets/icons/FactorIcon";
import PersonIcon from "assets/icons/Person";
import BasicButton from "components/BasicInputs/BasicButton";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useFormikContext } from "formik";
import { formatPrice, getDefaultCurrency } from "helpers";
import { MiladiToJalali } from "helpers/dataFormat";
import { useAppDispatch, useAppSelector } from "store/store";

export default function InfoSection() {
  const data = useFormikContext<InstallmentData>();
  const dispatch = useAppDispatch();
  const store = useAppSelector((x) => x);
  const token = store.businessReducer.business.token;
  const types = [
    {
      name: "person",
      label: "دریافت از اشخاص",
      icon: PersonIcon,
    },
    {
      name: "factor",
      // label: "فاکتور های فروش",
      label: `فاکتور های ${data?.values?.tab == 1 ? "خرید" : "فروش"}`,
      icon: FactorIcon,
    },
  ];

  const tabTypes = [
    { name: "receive", label: "پرداخت", factorType: '["buy"]' },
    { name: "payment", label: "دریافت", factorType: '["sale"]' },
  ];
  const tabType = tabTypes[data.values.tab ?? 0];

  const payers: { [key: string]: Payer } = {
    factor: {
      label: "فاکتور",
      name: "factor",
      options: store.factorReducer.factors.map((row: any) => {
        const splitedArr = row.dueDate.split('-')
        const shamsiDate = MiladiToJalali(Number(splitedArr[0]), Number(splitedArr[1]), Number(splitedArr[2]), true) as string
        return { ...row, label: `${row.label} - ${shamsiDate} - ${formatPrice(row.totalPrice)} ${getDefaultCurrency(row.CurrencyId).en_title}` }
      }) as Factor[],
      defaultValue: data.values.factorId,
      refreshList: () => {
        let factorType = "";
        if (data.values.tab === 0 || data.values.tab === undefined) {
          factorType = '["sale"]';
        } else {
          factorType = '["buy"]';
        }
        dispatch(apiFactorsList(token, factorType, "installment"));
      },
      onChange: (val, f: Factor) => {
        data.setFieldValue("totalPrice", f.totalPrice);
        data.setFieldValue("factorId", val);
        data.setFieldValue("description", `اقساط برای ${f.title}`);
      },
    },
    person: {
      label: `${tabType.label} کننده`,
      name: "person",
      options: store.personReducer.allPerson as Person[],
      defaultValue: data.values.personId,
      refreshList: () => dispatch(apiPersonsList(token, "allPerson")),
      onChange: (val, p: Person) => {
        data.setFieldValue("personId", val);
        data.setFieldValue("description", `اقساط برای ${p.nickName}`);
      },
    },
  };

  const payer = payers[data.values.type || "person"];

  return (
    <div className="flex flex-col gap-8">
      {/* ------------------------------------------------------------------------- */
      /*                                    TYPE                                    */
      /* -------------------------------------------------------------------------- */}
      <div className="flex flex-col gap-4">
        <span>قسط بندی برای:</span>
        <div className="flex items-center gap-4">
          {types.map((type, index) => {
            const active = (data.values.type || "person") === type.name;
            return (
              <BasicButton
                key={type.name}
                variant="outlined"
                color={active ? "primary" : "disabled"}
                onClick={() => {
                  data.setFieldValue("type", type.name);
                  if (type.name === "factor") {
                    let factorType = "";
                    if (data.values.tab === 0 || data.values.tab === undefined) {
                      factorType = '["sale"]';
                    } else {
                      factorType = '["buy"]';
                    }
                    dispatch(apiFactorsList(token, factorType, "installment"));
                  }
                }}
              >
                <span>{<type.icon className="w-6 h-6" color={active ? "#1062D0" : "#8D8E8F"} />}</span>
                <span className={`${active ? "text-blue-1" : "text-dark-3"} text-xs`}>{type.label}</span>
                {active && (
                  <span className="absolute flex items-center justify-center w-5 h-5 rounded-full -top-2 -right-2 bg-blue-1">
                    <Check className="text-xs text-white" />
                  </span>
                )}
              </BasicButton>
            );
          })}
        </div>
      </div>

      {/* ------------------------------------------------------------------------- */
      /*                                    PAYER                                   */
      /* -------------------------------------------------------------------------- */}
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="min-w-[320px]">
          <BasicSelect {...payer} withRefresh withSearch required />
        </div>
        <div className="min-w-[300px]">
          <BasicTextInput
            label="توضیحات"
            val={data.values.description}
            onChange={(val) => data.setFieldValue("description", val)}
          />
        </div>
      </div>
    </div>
  );
}
